/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Site/SiteHeader',[
    'jquery',
    'global/all',
    'modules/User/Users',
    'global/UI/SetupGlobals'
], function($, Roc, Users, SetupGlobals) {
    'use strict';

    var selector = '.headerLinks.headerLogin';
    var template = '#siteHeader-Tmp';
    var homepageRedirect;
    
    function renderTemplate() {
        Roc.Logger.debug('Reloading User Data...');

        $.ajax({
            url: '/ajax/SiteHeader',
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            complete: function (xhr) {
                var response = xhr.responseJSON || {};

                Roc.UI.template(template, response).then(function (renderedTemplate) {
                    $(selector).html(renderedTemplate);
                    SetupGlobals.accountNavPrepender();
                });

            }
        });
    }

    function logoutEvt() {
        $(document).on('click', '.headerLink-logout', function (e) {
            e.preventDefault();
            homepageRedirect = true; // set to 'true' - when callback function is called, user will be redirected to the homepage
            Users.logout(); // call logout function in Users module (and wait for callback)
        });
    }
    function signinEvt() {
        $(document)
            .off('click', '.headerLink-signin.disabled')
            .on('click', '.headerLink-signin.disabled', function (e) {
                // if our signin link is disabled, swallow the event
                e.preventDefault();
            });
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.users.LOGOUT, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success) {
                if (homepageRedirect) {
                    window.location.href = '/';
                } else {
                    renderTemplate();
                }
            }
        });
        Roc.EventManager.bind(Roc.Events.users.LOGIN, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success) {
                renderTemplate();
            }
        });
        Roc.EventManager.bind(Roc.Events.users.REGISTER, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success) {
                renderTemplate();
            }
        });
        logoutEvt();
        signinEvt();

        $(function () {
            renderTemplate();
        });
    }

    function init() {
        // this will be set to 'true' when user click any of logout links in the site header widget
        homepageRedirect = false;
        bindEvents();
    }

    // public methods
    var SiteHeader = {
        init: init,
        reload: renderTemplate
    };

    Roc.Logger.debug('SiteHeader.js Loaded:', SiteHeader);

    // return public methods
    return SiteHeader;

});
